import * as React from 'react';
import { ModalContainer, LabelButton, Icon } from '@teamsnap/snap-ui';

type Props = {
  isOpen: boolean;
  paymentsEnabled: boolean;
  closeFn: () => void;
  onSubmit: () => void;
  allowSave?: boolean;
};

function getContent(allowSave: boolean, paymentsEnabled: boolean) {
  if (!allowSave) {
    return 'This registration can be opened once a verified account has been selected.';
  }

  return paymentsEnabled ?
    'Saving with this account selection will allow you to open your registration form and collect payments, but payouts will be disabled until the merchant account is approved.'
    : 'Saving with this account selection will prevent registrant payments from being processed and the form will need to be manually reopened once the account has been verified.';
}

const UnapprovedMerchantAccountModal: React.FC<Props> = ({
  isOpen,
  paymentsEnabled,
  closeFn,
  onSubmit,
  allowSave = true,
}) => (
  <div style={{ zIndex: 99999999, position: 'absolute' }} data-testid="UnapprovedMerchantAccountModal--wrapper">
    <ModalContainer
      data-testid="UnapprovedMerchantAccountModal--container"
      isOpen={isOpen}
      paymentsEnabled={paymentsEnabled}
      onClose={closeFn}
      closeButton={false}
      disableOverlayClose
    >
      <div className="sui-p-2">
        <div className="sui-flex sui-items-center sui-mb-4">
          <Icon filled name="report" size="xl" className="u-colorNegative" />
          <h2 className="sui-heading-sm sui-ml-1">Merchant account verification required</h2>
        </div>

        <div className="sui-body sui-mb-4">
          <p className="sui-mb-4">The merchant account selected for this form requires verification.</p>

          <p className="sui-mb-4">
            {getContent(allowSave, paymentsEnabled)}
          </p>

          <p>
            Click <strong>Select merchant account</strong> to select a verified account for this registration form.
          </p>
        </div>

        <div className="sui-flex sui-justify-end">
          <LabelButton
            onClick={closeFn}
            variantType="secondary"
            data-testid="UnapprovedMerchantAccountModal--close-button"
          >
            {allowSave ? 'Save and exit' : 'Close'}
          </LabelButton>

          <LabelButton
            onClick={onSubmit}
            className="sui-ml-1"
            data-testid="UnapprovedMerchantAccountModal--select-merchant-account-button"
          >
            Select merchant account
          </LabelButton>
        </div>
      </div>
    </ModalContainer>
  </div>
);

export default UnapprovedMerchantAccountModal;
